import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-e-sign-pdf',
  templateUrl: './esignPdf.component.html',
  styleUrls: ['./esignPdf.component.css']
})
export class ESignPdfComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }
}
